import script from "./TextInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextInput.vue?vue&type=script&setup=true&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=060f2fe4&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060f2fe4"]])

export default __exports__